import type { TokenInfo } from '@yoop/server-model/token-info';
import { OfferSubStatus } from '@yoop/server-model/token-info';
import type { CustomerOrderReceiptResponse } from '@yoop/data-access-model';
import { owned } from '@yoop/util-token/predicate';

/**
 * Predicate for tokens for which we can see the receipt. See notes in canSeeReceiptButton.
 * @param token
 */
export const canSeeReceipt = (token: TokenInfo): boolean =>
  owned(token) &&
  token.offerResponse?.offerSubStatus !== OfferSubStatus.REFUNDED &&
  parseFloat(token.offerResponse?.tokenPrice?.totalAmount ?? '0') > 0;

export const hasPaidOffer = (receipt: CustomerOrderReceiptResponse): boolean =>
  receipt.offerResponseList.some(
    (offer): boolean =>
      offer?.offerSubStatus !== OfferSubStatus.REFUNDED &&
      parseFloat(offer?.tokenPrice?.totalAmount ?? '0') > 0,
  );
